var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnrichments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5459 13.046C12.3743 13.046 13.0459 12.3744 13.0459 11.546C13.0459 10.7175 12.3743 10.046 11.5459 10.046C10.7175 10.046 10.0459 10.7175 10.0459 11.546C10.0459 12.3744 10.7175 13.046 11.5459 13.046Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0208 14.0208C17.9261 10.1156 19.9838 5.84172 18.617 4.47489C17.2502 3.10805 12.9763 5.16584 9.07107 9.07108C5.16582 12.9763 3.10804 17.2502 4.47487 18.617C5.84171 19.9839 10.1156 17.9261 14.0208 14.0208Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.617 18.617C19.9838 17.2502 17.9261 12.9763 14.0208 9.07109C10.1156 5.16585 5.84171 3.10806 4.47487 4.47489C3.10804 5.84173 5.16583 10.1156 9.07107 14.0208C12.9763 17.9261 17.2502 19.9839 18.617 18.617Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnrichments);
export default __webpack_public_path__ + "static/media/icon_enrichments.594a8f16cb5b0e0cf007fe8486cc7e0a.svg";
export { ForwardRef as ReactComponent };